import React, { memo, useState, useMemo } from 'react'
import { Select } from '@ow/comps'
import { SearchIcon } from '@ow/icons'

const SeachIcon = () => {
  return (
    <div className="mr-2">
      <SearchIcon width={16} height={16} fill="#999999" />
    </div>
  )
}

const UserSelect = ({ userList, onSelect }) => {
  const [selected, setSelected] = useState([])
  const options = useMemo(
    () =>
      userList
        .filter((u) => !selected.includes(u.id))
        .map((u) => ({ value: u.id, label: u.name, name: u.name })),
    [userList, selected]
  )

  const onChange = (v) => {
    const ids = v.map((o) => o.value)
    setSelected(ids)
    if (onSelect) onSelect(ids)
  }
  return (
    <Select
      clearable
      multi
      openMenuOnClick={false}
      closeMenuOnSelect={false}
      components={{ DropdownIndicator: SeachIcon }}
      options={options}
      onChange={onChange}
    />
  )
}

export default memo(UserSelect)
